import { ExportType } from '../interfaces';
import { Values } from '../interfaces';
import {
  CreatePayoutData,
  Filters,
  FlowType,
  Payout,
  PayoutCreationStep,
  PayoutContact,
  PayoutContactListItem,
  PayoutFee,
  PurposeOfPayout,
  PayoutEnabledCountryConfiguration,
  RequiredFieldsResponse,
  CreateBeneficiaryRequest,
  CreateBeneficiaryResponse,
  AddBeneficiaryBankAccountRequest,
} from './interfaces';

export enum PayoutsActionType {
  GET_PAYOUTS = 'PAYOUTS/GET_PAYOUTS',
  GET_PAYOUTS_SUCCESS = 'PAYOUTS/GET_PAYOUTS_SUCCESS',
  GET_PAYOUTS_ERROR = 'PAYOUTS/GET_PAYOUTS_ERROR',
  GET_BANKS = 'PAYOUTS/GET_BANKS',
  GET_BANKS_SUCCESS = 'PAYOUTS/GET_BANKS_SUCCESS',
  GET_BANKS_ERROR = 'PAYOUTS/GET_BANKS_ERROR',
  REQUEST_PAYOUT = 'PAYOUTS/REQUEST_PAYOUT',
  REQUEST_PAYOUT_SUCCESS = 'PAYOUTS/REQUEST_PAYOUT_SUCCESS',
  REQUEST_PAYOUT_ERROR = 'PAYOUTS/REQUEST_PAYOUT_ERROR',
  SET_PAYOUT_DETAIL = 'PAYOUTS/SET_PAYOUT_DETAIL',
  GET_PAYOUT_DETAIL = 'PAYOUTS/GET_PAYOUT_DETAIL',
  GET_PAYOUT_DETAIL_SUCCESS = 'PAYOUTS/GET_PAYOUT_DETAIL_SUCCESS',
  GET_PAYOUT_DETAIL_ERROR = 'PAYOUTS/GET_PAYOUT_DETAIL_ERROR',
  EXPORT_PAYOUT_DETAIL = 'PAYOUTS/EXPORT_PAYOUT_DETAIL',
  SHOW_EXPORT_PAYOUTS = 'PAYOUTS/SHOW_EXPORT_PAYOUTS',
  EXPORT_PAYOUTS = 'PAYOUTS/EXPORT_PAYOUTS',
  EXPORT_PAYOUTS_SUCCESS = 'PAYOUTS/EXPORT_PAYOUTS_SUCCESS',
  EXPORT_PAYOUTS_ERROR = 'PAYOUTS/EXPORT_PAYOUTS_ERROR',
  START_CREATE_PAYOUT = 'PAYOUTS/START_CREATE_PAYOUT',
  SET_CREATE_PAYOUT_STEP = 'PAYOUTS/SET_CREATE_PAYOUT_STEP',
  SET_CREATE_PAYOUT_SUB_VIEW = 'PAYOUTS/SET_CREATE_PAYOUT_SUB_VIEW',
  SET_CREATE_PAYOUT_DATA = 'PAYOUTS/SET_CREATE_PAYOUT_DATA',
  GET_REQUIRED_FIELDS = 'PAYOUTS/GET_REQUIRED_FIELDS',
  GET_REQUIRED_FIELDS_SUCCESS = 'PAYOUTS/GET_REQUIRED_FIELDS_SUCCESS',
  GET_REQUIRED_FIELDS_ERROR = 'PAYOUTS/GET_REQUIRED_FIELDS_ERROR',
  GET_PAYOUT_FEE = 'PAYOUTS/GET_PAYOUT_FEE',
  GET_PAYOUT_FEE_SUCCESS = 'PAYOUTS/GET_PAYOUT_FEE_SUCCESS',
  GET_PAYOUT_FEE_ERROR = 'PAYOUTS/GET_PAYOUT_FEE_ERROR',
  VALIDATE_PARTIAL_PAYOUT = 'PAYOUTS/VALIDATE_PARTIAL_PAYOUT',
  VALIDATE_PARTIAL_PAYOUT_SUCCESS = 'PAYOUTS/VALIDATE_PARTIAL_PAYOUT_SUCCESS',
  VALIDATE_PARTIAL_PAYOUT_ERROR = 'PAYOUTS/VALIDATE_PARTIAL_PAYOUT_ERROR',
  CONFIRM_PAYOUT = 'PAYOUTS/CONFIRM_PAYOUT',
  CONFIRM_PAYOUT_SUCCESS = 'PAYOUTS/CONFIRM_PAYOUT_SUCCESS',
  CONFIRM_PAYOUT_ERROR = 'PAYOUTS/CONFIRM_PAYOUT_ERROR',
  RESET_CREATE_PAYOUT = 'PAYOUTS/RESET_CREATE_PAYOUT',
  VERIFY_OTP_CONFIGURED = 'PAYOUTS/VERIFY_OTP_CONFIGURED',
  VERIFY_OTP_CONFIGURED_SUCCESS = 'PAYOUTS/VERIFY_OTP_CONFIGURED_SUCCESS',
  VERIFY_OTP_CONFIGURED_ERROR = 'PAYOUTS/VERIFY_OTP_CONFIGURED_ERROR',
  GET_PAYOUT_COUNTRY_CONFIGURATIONS = 'PAYOUTS/GET_PAYOUT_COUNTRY_CONFIGURATIONS',
  GET_PAYOUT_COUNTRY_CONFIGURATIONS_SUCCESS = 'PAYOUTS/GET_PAYOUT_COUNTRY_CONFIGURATIONS_SUCCESS',
  GET_PAYOUT_COUNTRY_CONFIGURATIONS_ERROR = 'PAYOUTS/GET_PAYOUT_COUNTRY_CONFIGURATIONS_ERROR',
  GET_PAYOUT_CURRENCIES = 'PAYOUTS/GET_PAYOUT_CURRENCIES',
  GET_PAYOUT_CURRENCIES_SUCCESS = 'PAYOUTS/GET_PAYOUT_CURRENCIES_SUCCESS',
  GET_PAYOUT_CURRENCIES_ERROR = 'PAYOUTS/GET_PAYOUT_CURRENCIES_ERROR',
  GET_PAYOUT_CONTACTS = 'PAYOUTS/GET_PAYOUT_CONTACTS',
  GET_PAYOUT_CONTACTS_SUCCESS = 'PAYOUTS/GET_PAYOUT_CONTACTS_SUCCESS',
  GET_PAYOUT_CONTACTS_ERROR = 'PAYOUTS/GET_PAYOUT_CONTACTS_ERROR',
  GET_PAYOUT_CONTACTS_LIST = 'PAYOUTS/GET_PAYOUT_CONTACTS_LIST',
  GET_PAYOUT_CONTACTS_LIST_SUCCESS = 'PAYOUTS/GET_PAYOUT_CONTACTS_LIST_SUCCESS',
  GET_PAYOUT_CONTACTS_LIST_ERROR = 'PAYOUTS/GET_PAYOUT_CONTACTS_LIST_ERROR',
  GET_PAYOUT_CONTACT_VALIDATION_LINK = 'PAYOUTS/GET_PAYOUT_CONTACT_VALIDATION_LINK',
  REVALIDATE_PAYOUT_CONTACT = 'PAYOUTS/REVALIDATE_PAYOUT_CONTACT',
  DELETE_PAYOUT_CONTACT_BANK_ACCOUNT = 'PAYOUTS/DELETE_PAYOUT_CONTACT_BANK_ACCOUNT',
  SET_PAYOUT_CONTACT_BANK_ACCOUNT_PREFERRED = 'PAYOUTS/SET_PAYOUT_CONTACT_BANK_ACCOUNT_PREFERRED',
  LOAD_BENEFICIARY_REQUIREMENTS = 'PAYOUTS/LOAD_BENEFICIARY_REQUIREMENTS',
  LOAD_BENEFICIARY_BANKS = 'PAYOUTS/LOAD_BENEFICIARY_BANKS',
  CREATE_PAYOUT_BENEFICIARY = 'PAYOUTS/CREATE_PAYOUT_BENEFICIARY',
  ADD_PAYOUT_BENEFICIARY_BANK_ACCOUNT = 'PAYOUTS/ADD_PAYOUT_BENEFICIARY_BANK_ACCOUNT',
  UPDATE_PAYOUT_BENEFICIARY_BANK_ACCOUNT = 'PAYOUTS/UPDATE_PAYOUT_BENEFICIARY_BANK_ACCOUNT',
  SHOW_EXPORT_PAYOUT_CONTACTS = 'PAYOUTS/SHOW_EXPORT_PAYOUT_CONTACTS',
  EXPORT_PAYOUT_CONTACTS = 'PAYOUTS/EXPORT_PAYOUT_CONTACTS',
  EXPORT_PAYOUT_CONTACTS_SUCCESS = 'PAYOUTS/EXPORT_PAYOUT_CONTACTS_SUCCESS',
  EXPORT_PAYOUT_CONTACTS_ERROR = 'PAYOUTS/EXPORT_PAYOUT_CONTACTS_ERROR',
}

export const getPayouts = (page?: number, filter?: Filters) => ({
  type: PayoutsActionType.GET_PAYOUTS,
  page,
  filter,
});

export const getPayoutsSuccess = (response: any) => ({
  type: PayoutsActionType.GET_PAYOUTS_SUCCESS,
  response,
});

export const getPayoutsError = (error: any) => ({
  type: PayoutsActionType.GET_PAYOUTS_ERROR,
  error,
});

export const getBanks = (country: string) => ({
  type: PayoutsActionType.GET_BANKS,
  country,
});

export const getBanksSuccess = (response: any) => ({
  type: PayoutsActionType.GET_BANKS_SUCCESS,
  response,
});

export const getBanksError = (error: any) => ({
  type: PayoutsActionType.GET_BANKS_ERROR,
  error,
});

export const sendRequestPayout = (values: Values) => ({
  type: PayoutsActionType.REQUEST_PAYOUT,
  values,
});

export const sendRequestPayoutSuccess = (response: any) => ({
  type: PayoutsActionType.REQUEST_PAYOUT_SUCCESS,
  response,
});

export const sendRequestPayoutError = (error: any) => ({
  type: PayoutsActionType.REQUEST_PAYOUT_ERROR,
  error,
});

export const setPayoutDetail = (data: Payout) => ({
  type: PayoutsActionType.SET_PAYOUT_DETAIL,
  data,
});

export const getPayoutDetail = (id: number) => ({
  type: PayoutsActionType.GET_PAYOUT_DETAIL,
  id,
});

export const getPayoutDetailSuccess = (response: any) => ({
  type: PayoutsActionType.GET_PAYOUT_DETAIL_SUCCESS,
  response,
});

export const getPayoutDetailError = (error: any) => ({
  type: PayoutsActionType.GET_PAYOUT_DETAIL_ERROR,
  error,
});

export const exportPayoutDetail = (id: number) => ({
  type: PayoutsActionType.EXPORT_PAYOUT_DETAIL,
  id,
});

export const showExportPayouts = (show: boolean) => ({
  type: PayoutsActionType.SHOW_EXPORT_PAYOUTS,
  show,
});

export const exportPayouts = (filter: string, type: ExportType) => ({
  type: PayoutsActionType.EXPORT_PAYOUTS,
  filter,
  exportType: type,
});

export const exportPayoutsSuccess = (response: any, exportType: ExportType) => ({
  type: PayoutsActionType.EXPORT_PAYOUTS_SUCCESS,
  response,
  exportType,
});

export const exportPayoutsError = (error: any) => ({
  type: PayoutsActionType.EXPORT_PAYOUTS_ERROR,
  error,
});

export const startCreatePayout = () => ({
  type: PayoutsActionType.START_CREATE_PAYOUT,
});

export const setCreatePayoutStep = (step: PayoutCreationStep) => ({
  type: PayoutsActionType.SET_CREATE_PAYOUT_STEP,
  step,
});

export const setCreatePayoutSubView = (subView: 'country' | 'bank-data') => ({
  type: PayoutsActionType.SET_CREATE_PAYOUT_SUB_VIEW,
  subView,
});

export const setCreatePayoutData = (
  data: Partial<CreatePayoutData> & { bankOptions?: Array<{ code: string; name: string }> }
) => ({
  type: PayoutsActionType.SET_CREATE_PAYOUT_DATA,
  data,
});

export const getRequiredFields = (country: string, flowType: FlowType) => ({
  type: PayoutsActionType.GET_REQUIRED_FIELDS,
  country,
  flowType,
});

export const getRequiredFieldsSuccess = (response: RequiredFieldsResponse) => ({
  type: PayoutsActionType.GET_REQUIRED_FIELDS_SUCCESS,
  response,
});

export const getRequiredFieldsError = (error: any) => ({
  type: PayoutsActionType.GET_REQUIRED_FIELDS_ERROR,
  error,
});

export const getPayoutFee = (amount: number, currency: string, country: string) => ({
  type: PayoutsActionType.GET_PAYOUT_FEE,
  amount,
  currency,
  country,
});

export const getPayoutFeeSuccess = (response: PayoutFee) => ({
  type: PayoutsActionType.GET_PAYOUT_FEE_SUCCESS,
  response,
});

export const getPayoutFeeError = (error: any) => ({
  type: PayoutsActionType.GET_PAYOUT_FEE_ERROR,
  error,
});

export const validatePartialPayout = (values: Record<string, string | number>) => ({
  type: PayoutsActionType.VALIDATE_PARTIAL_PAYOUT,
  values,
});

export const validatePartialPayoutSuccess = (response: any) => ({
  type: PayoutsActionType.VALIDATE_PARTIAL_PAYOUT_SUCCESS,
  response,
});

export const validatePartialPayoutError = (error: any) => ({
  type: PayoutsActionType.VALIDATE_PARTIAL_PAYOUT_ERROR,
  error,
});

export const confirmPayout = (otpCode: string) => ({
  type: PayoutsActionType.CONFIRM_PAYOUT,
  otpCode,
});

export const confirmPayoutSuccess = (response: any) => ({
  type: PayoutsActionType.CONFIRM_PAYOUT_SUCCESS,
  response,
});

export const confirmPayoutError = (error: any) => ({
  type: PayoutsActionType.CONFIRM_PAYOUT_ERROR,
  error,
});

export const resetCreatePayout = () => ({
  type: PayoutsActionType.RESET_CREATE_PAYOUT,
});

export const verifyOtpConfigured = () => ({
  type: PayoutsActionType.VERIFY_OTP_CONFIGURED,
});

export const verifyOtpConfiguredSuccess = (response: any) => ({
  type: PayoutsActionType.VERIFY_OTP_CONFIGURED_SUCCESS,
  response,
});

export const verifyOtpConfiguredError = (error: any) => ({
  type: PayoutsActionType.VERIFY_OTP_CONFIGURED_ERROR,
  error,
});

export const getPayoutCountryConfigurations = () => ({
  type: PayoutsActionType.GET_PAYOUT_COUNTRY_CONFIGURATIONS,
});

export const getPayoutCountryConfigurationsSuccess = (response: PayoutEnabledCountryConfiguration[]) => ({
  type: PayoutsActionType.GET_PAYOUT_COUNTRY_CONFIGURATIONS_SUCCESS,
  response,
});

export const getPayoutCountryConfigurationsError = (error: any) => ({
  type: PayoutsActionType.GET_PAYOUT_COUNTRY_CONFIGURATIONS_ERROR,
  error,
});

export const getPayoutCurrencies = (country: string) => ({
  type: PayoutsActionType.GET_PAYOUT_CURRENCIES,
  country,
});

export const getPayoutCurrenciesSuccess = (response: any) => ({
  type: PayoutsActionType.GET_PAYOUT_CURRENCIES_SUCCESS,
  response,
});

export const getPayoutCurrenciesError = (error: any) => ({
  type: PayoutsActionType.GET_PAYOUT_CURRENCIES_ERROR,
  error,
});

export const getPayoutContacts = (merchantId: string) => ({
  type: PayoutsActionType.GET_PAYOUT_CONTACTS,
  merchantId,
});

export const getPayoutContactsSuccess = (response: PayoutContact[]) => ({
  type: PayoutsActionType.GET_PAYOUT_CONTACTS_SUCCESS,
  response,
});

export const getPayoutContactsError = (error: any) => ({
  type: PayoutsActionType.GET_PAYOUT_CONTACTS_ERROR,
  error,
});

export const getPayoutContactsList = (merchantId: string) => ({
  type: PayoutsActionType.GET_PAYOUT_CONTACTS_LIST,
  merchantId,
});

export const getPayoutContactsListSuccess = (response: PayoutContactListItem[]) => ({
  type: PayoutsActionType.GET_PAYOUT_CONTACTS_LIST_SUCCESS,
  response,
});

export const getPayoutContactsListError = (error: any) => ({
  type: PayoutsActionType.GET_PAYOUT_CONTACTS_LIST_ERROR,
  error,
});

export const getPayoutContactValidationLink = (
  merchantId: string,
  beneficiaryId: string,
  onSuccess: (validationLink: string) => void,
  onError?: () => void
) => ({
  type: PayoutsActionType.GET_PAYOUT_CONTACT_VALIDATION_LINK,
  merchantId,
  beneficiaryId,
  onSuccess,
  onError,
});

export const revalidatePayoutContact = (
  merchantId: string,
  beneficiaryId: string,
  onSuccess: () => void,
  onError?: () => void
) => ({
  type: PayoutsActionType.REVALIDATE_PAYOUT_CONTACT,
  merchantId,
  beneficiaryId,
  onSuccess,
  onError,
});

export const deletePayoutContactBankAccount = (
  merchantId: string,
  beneficiaryId: string,
  accountId: string,
  onSuccess: () => void,
  onError?: () => void
) => ({
  type: PayoutsActionType.DELETE_PAYOUT_CONTACT_BANK_ACCOUNT,
  merchantId,
  beneficiaryId,
  accountId,
  onSuccess,
  onError,
});

export const setPayoutContactBankAccountPreferred = (
  merchantId: string,
  beneficiaryId: string,
  accountId: string,
  onSuccess: () => void,
  onError?: () => void
) => ({
  type: PayoutsActionType.SET_PAYOUT_CONTACT_BANK_ACCOUNT_PREFERRED,
  merchantId,
  beneficiaryId,
  accountId,
  onSuccess,
  onError,
});

export const loadBeneficiaryRequirements = (
  country: string,
  flowType: FlowType,
  onSuccess: (fields: RequiredFieldsResponse) => void,
  onError: (error: any) => void
) => ({
  type: PayoutsActionType.LOAD_BENEFICIARY_REQUIREMENTS,
  country,
  flowType,
  onSuccess,
  onError,
});

export const loadBeneficiaryBanks = (
  country: string,
  onSuccess: (banks: Array<{ code: string; name: string }>) => void,
  onError: (error: any) => void
) => ({
  type: PayoutsActionType.LOAD_BENEFICIARY_BANKS,
  country,
  onSuccess,
  onError,
});

export const createPayoutBeneficiary = (
  merchantId: string,
  data: CreateBeneficiaryRequest,
  onSuccess: (response: CreateBeneficiaryResponse) => void,
  onError: (error: any) => void
) => ({
  type: PayoutsActionType.CREATE_PAYOUT_BENEFICIARY,
  merchantId,
  data,
  onSuccess,
  onError,
});

export const addPayoutBeneficiaryBankAccount = (
  merchantId: string,
  beneficiaryId: string,
  data: AddBeneficiaryBankAccountRequest,
  onSuccess: (response: any) => void,
  onError: (error: any) => void
) => ({
  type: PayoutsActionType.ADD_PAYOUT_BENEFICIARY_BANK_ACCOUNT,
  merchantId,
  beneficiaryId,
  data,
  onSuccess,
  onError,
});

export const updatePayoutBeneficiaryBankAccount = (
  merchantId: string,
  beneficiaryId: string,
  accountId: string,
  data: AddBeneficiaryBankAccountRequest,
  onSuccess: (response: any) => void,
  onError: (error: any) => void
) => ({
  type: PayoutsActionType.UPDATE_PAYOUT_BENEFICIARY_BANK_ACCOUNT,
  merchantId,
  beneficiaryId,
  accountId,
  data,
  onSuccess,
  onError,
});

export const showExportPayoutContacts = (show: boolean) => ({
  type: PayoutsActionType.SHOW_EXPORT_PAYOUT_CONTACTS,
  show,
});

export const exportPayoutContacts = (merchantId: string, filter: string, type: ExportType) => ({
  type: PayoutsActionType.EXPORT_PAYOUT_CONTACTS,
  merchantId,
  filter,
  exportType: type,
});

export const exportPayoutContactsSuccess = (response: any, exportType: ExportType) => ({
  type: PayoutsActionType.EXPORT_PAYOUT_CONTACTS_SUCCESS,
  response,
  exportType,
});

export const exportPayoutContactsError = (error: any) => ({
  type: PayoutsActionType.EXPORT_PAYOUT_CONTACTS_ERROR,
  error,
});
